import React from "react";
import { Label } from "@/components/ui/label";

/**
 * Field — shared label+hint wrapper used across the billing components.
 * Extracted from RABilling.jsx during the iter47 refactor pass.
 */
export default function Field({ label, children, hint }) {
  return (
    <div>
      <Label className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-1 block">{label}</Label>
      {children}
      {hint && <div className="text-[10.5px] text-slate-400 mt-0.5">{hint}</div>}
    </div>
  );
}
